import React from 'react';

export default function WrongAnswerIcon() {
    return (<svg className="feedback-icon right" width="60px" height="55px" viewBox="0 0 60 55" version="1.1">
        <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="Correct" fill="#FFFFFF">
                <path d="M13,24.7516494 L25.5,40.5 L50.3329275,2.25777726 C51.8250555,-0.0398983559 54.9024699,-0.689565257 57.1960796,0.799922321 C59.4943659,2.29244689 60.1522689,5.35826261 58.6557584,7.66268683 L29.6283095,52.3610383 C28.158422,54.6244666 25.150154,55.2886478 22.8682323,53.8840727 C22.0438905,53.5605855 21.295401,53.0116009 20.7217136,52.2502921 L0,24.7516494 L13,24.7516494 Z" id="Combined-Shape"></path>
            </g>
        </g>
    </svg>);
}


// WEBPACK FOOTER //
// ./src/campaign/challenges/quiz/right-answer-icon.jsx